(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/actions/get-items.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/actions/get-items.js');
"use strict";


const getItems = callback => (callbackFn, timeout) => {
  callback(undefined, callbackFn, timeout);
};
setGlobal('svs.components.selfserviceCart.fns.actions.getItems', getItems);

 })(window);